"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Role {
    constructor(obj) {
        this.id = obj.id || -1;
        this.name = obj.name || '';
    }
}
exports.default = Role;
Role.SUPER_ADMIN_ROLE = 'super_admin';
